/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InProgress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function InProgress({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/Job/Content/Content/InProgress"
  
}) {
let jobValueData = fromData.useDataFormat({ viewPath,
context: 'job',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 data="job"
 format="helpers.js getText"
 text={jobValueData}
/>
{children}
</React.Fragment>)
}